import { cached, tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

import { docsManager } from 'kolay';
import { lessonPath } from 'tutorial/utils';

import type Selected from './selected';
import type RouterService from '@ember/routing/router-service';

export default class DocsService extends Service {
  @service declare router: RouterService;
  @service declare selected: Selected;

  @tracked isViewingProse = true;

  get docs() {
    return docsManager(this);
  }

  @cached
  get tutorials() {
    return this.docs.pages ?? [];
  }

  get grouped() {
    return this.docs.tree ?? {};
  }

  get firstLesson(): string | undefined {
    const first = this.tutorials[0];

    return first ? lessonPath(first) : undefined;
  }

  get showAnswer() {
    return this.router.currentRoute?.queryParams?.['showAnswer'] === '1';
  }

  showMe = () => {
    this.#hideProse();
    this.router.transitionTo({ queryParams: { showAnswer: 1 } });
  };

  unShowMe = () => {
    this.#hideProse();
    this.router.transitionTo({ queryParams: { showAnswer: 0 } });
  };

  get currentPath(): string | undefined {
    if (!this.router.currentURL) return this.firstLesson;

    const [path] = this.router.currentURL.split('?');

    return path && path !== '/' ? path : this.firstLesson;
  }

  toggleProse = () => {
    if (this.isViewingProse) {
      return this.#hideProse();
    }

    this.#showProse();
  };

  #hideProse = () => {
    const words = document.querySelector('section[data-words]');

    if (words) {
      words.classList.add('-translate-x-full');
    }

    this.isViewingProse = false;
  };

  #showProse = () => {
    const words = document.querySelector('section[data-words]');

    if (words) {
      words.classList.remove('-translate-x-full');
    }

    this.isViewingProse = true;
  };
}
